import { tv } from 'tailwind-variants';

import { TypographyVariant } from './typography.type';

export const typographyStyles = tv({
  base: 'color-gray-700',
  variants: {
    variant: {
      [TypographyVariant.TITLE]: 'text-2xl sm:text-4xl text-gray-900 font-bold',
      [TypographyVariant.MODAL_TITLE]: 'text-2xl text-gray-900 font-bold',
      [TypographyVariant.LARGE_SUBTITLE]: 'text-xl sm:text-3xl text-gray-800',
      [TypographyVariant.MEDIUM_SUBTITLE]: 'text-lg sm:text-xl text-gray-800',
      [TypographyVariant.BODY_TEXT]: 'text-base text-gray-700',
      [TypographyVariant.BODY_STRONG]: 'text-lg sm:text-xl text-gray-800 font-semibold',
      [TypographyVariant.MEDIUM_BODY_TEXT]: 'text-sm text-gray-700',
      [TypographyVariant.SMALL_BODY_TEXT]: 'text-xs text-gray-700',
    },
  },
});

export const typographyHTMLTags = {
  [TypographyVariant.TITLE]: 'h1',
  [TypographyVariant.MODAL_TITLE]: 'h1',
  [TypographyVariant.LARGE_SUBTITLE]: 'h2',
  [TypographyVariant.MEDIUM_SUBTITLE]: 'h3',
  [TypographyVariant.BODY_TEXT]: 'p',
  [TypographyVariant.BODY_STRONG]: 'p',
  [TypographyVariant.MEDIUM_BODY_TEXT]: 'p',
  [TypographyVariant.SMALL_BODY_TEXT]: 'p',
};
